"use client";

import { useState, useEffect as useNativeEffect, useLayoutEffect as useNativeLayoutEffect } from "react";


type MaybeDestructor = (() => void) | void;
type Effect = () => MaybeDestructor;
type Dependencies = any[];


/**
 * same React.useNativeEffect() but with inverted parameters to improve readability.
 */
export function useEffect(effect: Effect): void; // runs every time...
export function useEffect(dependencies: Dependencies, effect: Effect): void;
export function useEffect(...param: [Effect] | [Dependencies, Effect]) {
	const [effect, maybeDependencies] =
		<[Effect, Dependencies?]>[...param.slice(-1), ...param.slice(0, -1)]

	useNativeEffect(effect, maybeDependencies);
}


/**
 * same React.useNativeLayoutEffect() but with inverted parameters to improve readability.
 */
export function useLayoutEffect(effect: Effect): void; // runs every time...
export function useLayoutEffect(dependencies: Dependencies, effect: Effect): void;
export function useLayoutEffect(...param: [Effect] | [Dependencies, Effect]) {
	const [effect, maybeDependencies] =
		<[Effect, Dependencies?]>[...param.slice(-1), ...param.slice(0, -1)]

	useNativeLayoutEffect(effect, maybeDependencies);
}


/**
 * effect executed only once, same as `useEffect([], effect)`.
 */
export function useMountEffect(initializer: Effect) {
	useEffect([], initializer);
}


/**
 * executed once when the component is created, before it is rendered.
 *
 * you can't set state or anything like that here, it's purely to set up
 * providers that don't trigger and re-render.
 */
export function useInitEffect(runnable: () => void): void {
	useState<void>(() => {
		runnable();
	});
}
